import { render, staticRenderFns } from "./LiveDataManually.vue?vue&type=template&id=615d9d13&scoped=true"
import script from "./LiveDataManually.vue?vue&type=script&lang=js"
export * from "./LiveDataManually.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d9d13",
  null
  
)

export default component.exports